import React, { useReducer, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { Store } from "../Store";
import { getError } from "../utils/error";
import { editReducer as reducer } from "../reducers/commonReducer";
import axiosInstance from "../utils/axiosUtil";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

export default function AdminLoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch: ctxDispatch } = useContext(Store);

  const navigate = useNavigate();
  const [{ loading }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data } = await axiosInstance.post("/auth/login", {
        email,
        password,
      });

      if (data?.token) {
        ctxDispatch({ type: "USER_SIGNIN", payload: { user: data.user, token: data.token } });
        localStorage.setItem("userInfo", JSON.stringify(data.user));
        localStorage.setItem("token", JSON.stringify(data.token));
        navigate("/admin/dashboard");
        dispatch({ type: "FETCH_SUCCESS" });
      } else {
        toast.error("Invalid response from server", { position: toast.POSITION.BOTTOM_CENTER });
      }
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
      toast.error(getError(err), { position: toast.POSITION.BOTTOM_CENTER });
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const backgroundStyle = {
    "--bg-image-url": `url(${process.env.PUBLIC_URL}/report-img.jpeg)`
  };

  return (
    <Container
      fluid
      className="p-0 vh-100 f-center flex-column login-page bg-image"
      style={backgroundStyle}
    >
      <div className="login-logo">
        <Link to="/" className="text-center">
          <span style={{ color: "#14b8a6" }}>
            <b>ElementalX Admin</b>
          </span>
        </Link>
      </div>

      <Card className="login-box">
        <Card.Body>
          <p className="text-center">Sign in to manage reports</p>
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="email" className="input-group mb-3">
              <Form.Control
                placeholder="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <InputGroup.Text>
                <FaEnvelope />
              </InputGroup.Text>
            </Form.Group>
            <Form.Group controlId="password" className="input-group mb-3">
              <Form.Control
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <InputGroup.Text onClick={toggleShowPassword} style={{ cursor: "pointer" }}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </InputGroup.Text>
            </Form.Group>
            <Row>
              <Col sm={12} className="text-end">
                <Button type="submit">
                  {loading ? <Spinner animation="border" size="sm" /> : "Sign In"}
                </Button>
              </Col>
            </Row>
          </Form>
          <ToastContainer />
        </Card.Body>
      </Card>
    </Container>
  );
}
